<template>
  <div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-bind:to="'/' + $i18n.locale + '/' + $t('settings.url')">
            {{ $t('settings.name') }}
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ $t('cashRegister.name') }}</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">
            {{ $t('cashRegister.edit') }}
          </h1>
          <p class="lead text-muted">
            {{ $route.params.property }}
          </p>
        </div>
      </header>
      <div class="content">
        <div class="row">
          <div class="col-md-6 border-right">
            <ValidationObserver v-slot="{ handleSubmit }" ref="form">
              <form id="propertyForm">

                <h5>{{ $t('information.company') }}</h5>

                <div class="form-group">
                  <label for="premise.title">{{ $t('title') }}</label>
                  <ValidationProvider name="title" vid="premise.title" rules="required" v-slot="{ errors }">
                    <input class="form-control" v-model="premise.title" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <label>{{ $t('taxNumber') }}</label>
                  <ValidationProvider name="tax number" vid="premise.taxNumner" rules="required" v-slot="{ errors }">
                    <input class="form-control" v-model="premise.taxNumber" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <h5>{{ $t('information.address') }}</h5>

                <Address v-bind.sync="{'address': premise.address}"></Address>

                <h5>{{ $t('information.cadastral') }}</h5>

                <div class="form-group">
                  <label for="premise.property.cadastralNumber">{{ $t('cadastralNumber') }}</label>
                  <ValidationProvider name="cadastral number" vid="premise.property.cadastralNumber" rules="required" v-slot="{ errors }">
                    <input class="form-control" v-model="premise.property.cadastralNumber" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <label for="premise.property.buildingNumber">{{ $t('buildingNumber') }}</label>
                  <ValidationProvider name="building number" vid="premise.property.buildingNumber" rules="required" v-slot="{ errors }">
                    <input class="form-control" v-model="premise.property.buildingNumbere" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <label for="premise.property.buildingSectionNumber">{{ $t('buildingSectionNumber') }}</label>
                  <ValidationProvider name="building section number" vid="premise.property.buildingSectionNumber" rules="required" v-slot="{ errors }">
                    <input class="form-control" v-model="premise.property.buildingSectionNumber" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>


                <div class="d-flex w-100">

                  <div class="btn-group btn-group-justified d-flex w-100 pb-5 pt-4">
                    <button type="button" name="save" class="btn btn-primary flex-grow-1" @click="handleSubmit(submit)">{{ $t('save') }}</button>
                  </div>
                </div>

              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const countryList = require('country-list');
import Address from './components/Address.vue';

export default {
  name: 'Blagajna',
  props: ['socket'],
  components: {
    Address
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name){
        vm.from = from.fullPath
      }
    });
  },
  data: () => ({
    from: null,
    "premise": {
      "address": {},
      "property": {}
    },
    "countries": countryList.getData()
  }),
  created(){
    if(this.$route.params.property){
      fetch(process.env.VUE_APP_API + '/properties/' + this.$route.params.property, {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          "CSRF-Token": this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(result => {
        console.log("wtf");
        console.log("result")
        this.property = result;
      })
    }
  },
  methods: {
    submit: function(status = null){

      let url = this.$route.params.property ? '/properties/' + this.$route.params.property : '/properties';
      let action = this.$route.params.property ? 'PUT' : 'POST';

      return fetch( process.env.VUE_APP_API + url, {
        method : action,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify({
          property: this.property,
          socket: {
            id: this.socket.id
          }
        })
      })
      .then(response => response.json())
      .then(response => {
        if(!response.error){
          if(this.from){
            this.$router.push(this.from);
          }else{
            this.$router.push('/' + this.$i18n.locale + '/' + this.$t('settings.url')+ '/' + this.$t('properties.url'));
          }
        }else{
          console.log(response.error);
          this.$refs.form.setErrors(response.error.messages);
        }
      });
    }
  }
}
</script>

<i18n>
{
  "en": {
    "settings": {
      "name": "Settings",
      "url": "settings"
    },
    "properties": {
      "name": "Properties",
      "url": "properties"
    },
    "cashRegister": {
      "name": "Cash Register",
      "url": "cash-register",
      "edit": "Edit Cash Register Data"
    },
    "property": {
      "create": "Create Property",
      "edit": "Edit Property"
    },
    "information": {
      "company": "Company Information",
      "contact": "Contact Information",
      "address": "Address",
      "cadastral": "Cadastral Information"
    },
    "title": "Company Title",
    "taxNumber": "Tax Number",
    "cadastralNumber": "Cadastral Number",
    "buildingNumber": "Cadastral Number",
    "buildingSectionNumber": "Cadastral Number",
    "save": "Shrani"
  },
  "sl": {
    "settings": {
      "name": "Nastavitve",
      "url": "nastavitve"
    },
    "properties": {
      "name": "Nastanitve",
      "url": "nastanitve"
    },
    "cashRegister": {
      "name": "Blagajna",
      "url": "blagajna",
      "edit": "Uredi podatke za davčno blagajno"
    },
    "property": {
      "create": "Ustvari nastanitev",
      "edit": "Uredi nastanitev"
    },
    "information": {
      "company": "Podatki podjetja",
      "contact": "Kontaktni podatki",
      "address": "Naslov",
      "cadastral": "Katastrski podatki"
    },
    "title": "Naziv podjetja",
    "taxNumber": "Davčna številka",
    "cadastralNumber": "Številka katastrske občine",
    "buildingNumber": "Številka stavbe",
    "buildingSectionNumber": "Številka dela stavbe",
    "save": "Shrani"
  }
}
</i18n>
